import { call } from '../core'

export function closeWebView() {
  return call('finCloseWebView')
}
